/* eslint-disable import/prefer-default-export */
export const selectConfig = state => state.config
